var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#50BEE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22906 30C6.89906 30 6.53906 29.8187 6.53906 29.38V23.7037C6.53906 23.3437 6.89906 23.0837 7.22906 23.0837H9.51781C14.0853 23.0837 13.9841 30 9.60656 30H7.22906ZM7.85906 24.3025V28.78H9.51781C12.2166 28.78 12.3353 24.3025 9.51781 24.3025H7.85906Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8078 30.1C15.9591 30.18 14.0391 28.95 14.0391 26.5012C14.0391 24.0425 15.9578 22.8337 17.8078 22.8337C19.5566 22.9225 21.3853 24.1325 21.3853 26.5012C21.3853 28.8712 19.5566 30.1 17.8078 30.1ZM17.6978 24.1337C16.5778 24.1337 15.3591 24.9237 15.3591 26.5025C15.3591 28.0725 16.5791 28.8725 17.6978 28.8725C18.8478 28.8725 20.0766 28.0725 20.0766 26.5025C20.0766 24.9225 18.8478 24.1337 17.6978 24.1337Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5625 26.4912C22.5625 24.5625 23.7725 22.9037 26.0713 22.9037C26.9413 22.9037 27.6313 23.1637 28.36 23.7937C28.63 24.0425 28.66 24.4825 28.39 24.7625C28.12 25.0012 27.71 24.9725 27.47 24.7325C27.0613 24.3025 26.6413 24.1837 26.0713 24.1837C24.5325 24.1837 23.7938 25.2737 23.7938 26.4925C23.7938 27.7325 24.5225 28.8712 26.0713 28.8712C26.6413 28.8712 27.1713 28.64 27.6313 28.2312C27.94 27.9912 28.37 28.11 28.55 28.3512C28.71 28.5712 28.7887 28.9412 28.44 29.29C27.74 29.9412 26.9012 30.0712 26.07 30.0712C23.6525 30.0712 22.5625 28.42 22.5625 26.4912Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.4698032b1567f6854d1d69ed7707fbc9.svg";
export { ForwardRef as ReactComponent };